import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { Observable, pipe } from 'rxjs';
import {catchError, map} from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { CommonService } from './common-service.service';
import { HttpService } from './http.service';
import { VehicleMaster, VehicleModelMap } from '../model/vehicle.model';
@Injectable({
  providedIn: 'root'
})
export class VehicleMasterService{
hostname=environment.apiEndpoint;
vehicleMasterObj:VehicleMaster;
modelMap: VehicleModelMap = new VehicleModelMap();
constructor(private _http : HttpClient, private commonService: CommonService, private httpService: HttpService) { }

  PostVehicle(servicePath:any,data : any){
    //debugger
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.post(this.hostname + servicePath, data, httpOptions).pipe(catchError(this.handleError));
  }

  GetVehicle(servicePath:any,data:any){
    //debugger
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.get<any>(this.hostname + servicePath, httpOptions).pipe(catchError(this.handleError))
  }

  ViewVehicle(servicePath:any){
    //debugger
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.get<any>(this.hostname + servicePath, httpOptions).pipe(catchError(this.handleError))
  }

  getSystemDate(servicePath:any){
    //debugger
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.get<any>(this.hostname + servicePath, httpOptions).pipe(catchError(this.handleError))
  }
  private handleError(error: HttpErrorResponse) {
    //debugger
    console.log(error)
    return Observable.throw(error.message || "Server Error")
  }
}
